import { rewardsApi } from '../../API/rewardsConfig'
import { RewardsResponse } from './types'

export const getRewards = async (): Promise<RewardsResponse> => {
    return await rewardsApi
        .get('/summary')
        .then((response) => {
            return response.data
        })
        .then((data) => data)
        .catch((error) => {
            console.error('[] Error:', error)
        })
}

export const claimChallenge = async (challengeId: number): Promise<RewardsResponse['rewards'][0]> => {
    return await rewardsApi
        .post(`/complete-challenge`, {
            challengeId,
        })
        .then((response) => {
            return response.data
        })
        .then((data) => data)
        .catch((error) => {
            console.error('[] Error:', error)
        })
}
